import {
  UseQueryOptions,
  keepPreviousData,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { MRT_PaginationState } from "material-react-table";

import { downloadFile } from "@/lib/common-utils";
import {
  KeyFilter,
  KeySort,
  ResultStatsRedisDto,
  StatServiceResponseDto,
  StatserviceQueryDto,
} from "@/shared/api";
import { RequiredError } from "@/shared/api/base";
import { useApi } from "@/shared/api/use-api";

export const useSysStatserviceQuery = (
  {
    period,
    filters,
    sort = [],
    pagination,
    enabledConditionalFields,
  }: {
    period: number;
    filters?: Set<KeyFilter>;
    sort?: KeySort[];
    pagination?: MRT_PaginationState;
    enabledConditionalFields?: Set<string>;
  },
  queryOptions?: Omit<UseQueryOptions<AxiosResponse<StatServiceResponseDto>>, "queryKey">
) => {
  const { sysStatserviceControllerApi } = useApi();
  return useQuery({
    queryKey: [`/sys-data/statservice`, filters, sort, pagination],
    queryFn: ({ signal }) => {
      const query: StatserviceQueryDto = {
        period: period,
        filters: filters,
        page: pagination
          ? { page_number: pagination.pageIndex, page_size: pagination.pageSize }
          : undefined,
        sort: sort,
        enabled_conditional_fields: enabledConditionalFields,
      };
      return sysStatserviceControllerApi.findStatserviceData(query, { signal });
    },
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
};

export const useSysStatserviceWpcQuery = (
  //TODO Refactor in future.Temporary solution
  { room, period }: { room: string; period: number },
  queryOptions?: Omit<UseQueryOptions<AxiosResponse<ResultStatsRedisDto[]>>, "queryKey">
) => {
  const { sysStatserviceControllerApi } = useApi();
  return useQuery({
    queryKey: [`/sys-data/statservice/wpc`, room, period],
    queryFn: ({ signal }) => {
      return sysStatserviceControllerApi.findStatserviceRedisData(
        { room, period },
        { signal }
      );
    },
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
};

export const useSysStatserviceExportCsvMutation = () => {
  const { sysStatserviceControllerApi } = useApi();
  type Options = {
    period: number;
    filters?: Set<KeyFilter>;
    columns_for_export?: Set<string>;
  };

  const mutationFn = async ({ period, filters, columns_for_export }: Options) => {
    const response = await sysStatserviceControllerApi.exportStatserviceToCsv({
      period,
      filters,
      columns_for_export,
    });
    downloadFile(response);
    return response;
  };

  return useMutation<AxiosResponse<string>, RequiredError, Options>({
    mutationFn: mutationFn,
  });
};
